import { useEffect, useState } from 'react';
import BoxStateDTO from '../../interfaces/dto/boxStateDTO';
import { getBoxState } from '../../services/boxstate';

const useBoxState = (): BoxStateDTO => {
  const [boxStateData, setBoxState] = useState<BoxStateDTO>({ boxState: '' });
  useEffect(() => {
    (async () => {
      const data = await getBoxState();
      setBoxState(data);
    })();
  }, []);
  return boxStateData;
};

export default useBoxState;
